import React, {FC, useState} from 'react';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {ReactComponent as SelectArrayIcon} from '../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../assets/i/arrow-up-icon.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {Options} from "./options/options";
import {Select} from "antd";
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {setFormAddTestAC} from "app/popups-reducer";
import {putLessonTest} from "features/model/service/lessons/lessons-test/gut-lesson-test/putLessonTest";
import {useParams} from "react-router-dom";


export const FormAddTest: FC = () => {
    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false]);
    const dispatch = useAppDispatch()
    const [open, setOpen] = useState<boolean>(false);
    const TestAllowedData = useAppSelector(state => state.testAllowed)
    const {lessonsId} = useParams()

    const optionsAddTest: Options[] = TestAllowedData?.items?.map((test) => ({
        value: test.id.toString(),
        label: test.title,
    })) || [];


    const onClickRowHandler = () => {
        setOpen(!open)
    }


    const [values, setValues] = useState<{
        addTest: string;
    }>({
        addTest: '',
    });

    const handleChange = (name: string, value: string) => {
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const onClickHandler = () => {
        dispatch(setFormAddTestAC(false))
    }


    const addOnClickHandler = (testId: number | undefined) => {
        if (testId) {
            dispatch(putLessonTest({lessonsId, testId}));
        }
    };


    return (
        <>
            <p className="h3 popup-title">Добавить тест</p>
            <div className="form gap">
                <div id="course-type-two" className="course-type" onClick={onClickRowHandler}>
                    <span className={values.addTest ? 'active-label' : ''}>Добавить тест</span>
                    <Select
                        id="courseType"
                        style={{ width: '100%'}}
                        value={values.addTest}
                        className="custom-select select-new"
                        onChange={(value) => handleChange('addTest', value.toString())}
                        options={optionsAddTest}
                        onFocus={() => handleFocus(0)}
                        onBlur={handleBlur}
                        suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                    />
                </div>
                <button
                    type="button"
                    className="new-button btn full-width"
                    onClick={() => addOnClickHandler(Number(values.addTest))}
                >
                    <span>Добавить</span>
                </button>
            </div>
            <span className="js-close-popup" onClick={onClickHandler}>
                <CloseIcon/>
            </span>
        </>
    );
};
